import type { FC } from 'react';
import { Avatar, Box, Chip, Stack, Typography } from '@mui/material';
import { Logout } from '@mui/icons-material';

import type { UserProfile } from '#packages/web/types/user-profile';

export type SignedInUserProps = {
  /**
   * Handler for logout action.
   */
  userProfile: UserProfile;

  /**
   * Sign out click handler.
   */
  onSignOutClick: () => void;
};

export const SignedInUser: FC<SignedInUserProps> = ({
  userProfile,
  onSignOutClick: signOutClick,
}) => (
  <Box sx={{ px: 1 }}>
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Avatar alt={userProfile.fullName} src={userProfile.avatarUrl}>
        {userProfile.avatarText}
      </Avatar>
      <Chip
        label="Sign Out"
        color="error"
        variant="outlined"
        size="small"
        icon={<Logout fontSize="small" />}
        sx={{ p: 0.5 }}
        onClick={signOutClick}
      />
    </Stack>
    <Typography variant="h6">{userProfile.fullName}</Typography>
    <Typography variant="caption">{userProfile.email}</Typography>
  </Box>
);
